import {SponsorTypeEnum} from 'modules/coupons/types';
import useEditPermissionGroup from 'modules/permission-groups/hooks/use-edit-permission-group';
import {
  cityPermissions,
  companyPermissions,
  franchisePermissions,
} from 'modules/permission-groups/util/permissions-select';
import React from 'react';
import {useParams} from 'react-router-dom';

import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditPermissionGroup: React.FC = () => {
  const {getInput, getSelect, getSection} = useFormInputs();
  const {id} = useParams();
  const sectionInputs = useFormInputs();

  return (
    <Edition
      titleBar={{
        title: 'Editar grupo de permissões',
      }}
      detailsUrl={`/permission-groups/${id}`}
      inputs={[
        getInput({name: 'name'}),
        getSelect({
          name: 'type',
          data: [
            {label: 'Empresa', value: SponsorTypeEnum.COMPANY},
            {label: 'Cidade', value: SponsorTypeEnum.CITY},
            {label: 'Franquia', value: SponsorTypeEnum.FRANCHISE},
          ],
          disabled: true,
        }),
        getSection({
          label: 'Permissões',
          inputs: (data) => {
            const permissionSelect =
              data.type === SponsorTypeEnum.COMPANY
                ? companyPermissions
                : data.type === SponsorTypeEnum.CITY
                ? cityPermissions
                : franchisePermissions;

            return Object.keys(permissionSelect).map((module) =>
              sectionInputs.getMultiSelect({
                name: `permissions.${module}`,
                label: permissionSelect[module].name,
                data: permissionSelect[module].permissions,
              }),
            );
          },
          hidden: (data) => !data.type,
        }),
      ]}
      translationKey="PermissionGroupProps"
      onSubmit={() => useEditPermissionGroup(id!)}
    />
  );
};

export default EditPermissionGroup;
